import React from 'react';
import { Box, Typography, Button, Fade } from '@mui/material';

const Hero: React.FC = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: '95vh',
        overflow: 'hidden',
      }}
    >
      {/* Background image with overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundImage: 'url(/hero.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          zIndex: 0,
          '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
          },
        }}
      />

      {/* Centered content using flex */}
      <Fade in timeout={1000}>
        <Box
          sx={{
            position: 'relative',
            zIndex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            width: '100%',
            textAlign: 'center',
            px: 2,
            maxWidth: 800,
            mx: 'auto',
          }}
        >
          <Typography
            variant="h2"
            component="h1"
            gutterBottom
            sx={{
              fontSize: {
                xs: '1.35rem',
                sm: '1.9rem',
                md: '2.6rem',
                lg: '3.2rem',
                xl: '4rem',
              },
              fontWeight: 500,
              fontFamily: "'Ethnocentric', 'Playfair Display SC', Georgia, serif",
              lineHeight: 1.08,
              letterSpacing: { xs: '0.08em', sm: '0.12em' },
              textTransform: 'uppercase',
              whiteSpace: { xs: 'normal', md: 'nowrap' },
              textAlign: 'center',
              wordBreak: 'break-word',
              // Elegant silver gradient:
              background: 'linear-gradient(90deg, #C0C0C0 0%, #F3F3F3 35%, #A9A9A9 70%, #EDEDED 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              // Subtle "sparkle" with a crisp highlight:
              textShadow: '0 1px 8px #ffffff99, 0 0px 2px #E5E5E5',
            }}
          >
            S&nbsp;y&nbsp;n&nbsp;c&nbsp;&nbsp;&nbsp;&nbsp;L&nbsp;o&nbsp;g&nbsp;i&nbsp;s&nbsp;t&nbsp;i&nbsp;c
          </Typography>

          <Typography
            variant="h6"
            sx={{
              mb: 4,
              fontSize: { xs: '1rem', md: '1.25rem' },
              color: '#D1D5DB', // Soft gray
              fontFamily: 'Source Sans Pro, sans-serif',
              textAlign: 'center',
            }}
          >
            Navigate complexity with clarity and confidence.
          </Typography>

          <Button
            variant="contained"
            size="large"
            href="#contact-banner"
            sx={{
              backgroundColor: '#002b54',
              fontFamily: 'Open Sans, sans-serif',
              px: 4,
              py: 1.5,
              fontSize: { xs: '0.9rem', sm: '1rem' },
              '&:hover': {
                backgroundColor: '#0A6FB3',
              },
            }}
          >
            Learn More
          </Button>
        </Box>
      </Fade>
    </Box>
  );
};

export default Hero;
